import { Show } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import { useSubscriptionsStyles } from './useSubscriptionsStyles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Box from '@material-ui/core/Box';
import CheckIcon from '@material-ui/icons/Check';
import Block from '@material-ui/icons/Block';
import BottomToolbar from '../../../components/Toolbar';
import RedirectButton from 'components/redirect-button';
import RelatedChallengesList from '../components/related-challenges-list';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const ShowSubscription = (props: any) => {
  const { record } = props;

  const classes = useSubscriptionsStyles();

  const rows = [
    {
      key: 'subscribers',
      name: 'Subscribers',
      details: record.subscribers || 0,
    },
    {
      key: 'active',
      name: 'Active',
      details: record.active ? <CheckIcon /> : <Block />,
    },
    {
      key: 'challenges',
      name: 'Challenges',
      details: record.subscriptionChallenges?.length || 0,
    },
  ];

  const renderRows = () =>
    rows.map(row => (
      <StyledTableRow key={row.key}>
        <StyledTableCell component="th" scope="row">
          {row.name}
        </StyledTableCell>
        <StyledTableCell align="right">{row.details}</StyledTableCell>
      </StyledTableRow>
    ));

  return (
    <Box>
      <Box
        display="flex"
        flexDirection="column"
        m={3}
        className={classes.content}
      >
        <Box mb={3}>{record.name}</Box>

        <Box>
          <Table className={classes.table} aria-label="customized table">
            <TableBody>{renderRows()}</TableBody>
          </Table>
        </Box>

        <Box my={3}>Challenges</Box>

        <RelatedChallengesList {...props} />
      </Box>

      <BottomToolbar
        hasSaveButton={false}
        backButton={
          <RedirectButton
            label="Go Back"
            redirectTo={{ pathname: `/subscription` }}
          />
        }
      />
    </Box>
  );
};

export const SubscriptionsView = (props: any) => {
  const classes = useSubscriptionsStyles();

  return (
    <Show {...props} className={classes.createBox}>
      <ShowSubscription {...props} />
    </Show>
  );
};
